import apiUrl from '../../../../../constants';
import axios from 'axios';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import { BasicSelect,MultiSelect } from 'vue-search-select'
import CreateClientAnnexures from './../CreateClientAnnexures';
import Pagination from './../../../../shared/components/pagination'
import CustomExpandableTable from './../../../../shared/components/customExpandableTable';
import ClientService from './../../../services/clientmanagement.service';
import Loader from '../../../../shared/components/loader';
import Util from './../../../../shared/util/util'
import CONSTANT from './../../../../shared/constants/constant'
import Multiselect from 'vue-multiselect'

export default {
  name: 'ClientAnnexureListing',
  components: {
    VueElementLoading,
    Pagination,
    BasicSelect,
    CreateClientAnnexures,
    CustomExpandableTable,
    Loader,
    Multiselect
  },
  data: function() {
    return {
      createContracts:false,
      AnnexureList:[],
      isLoading:false,
      showAnnexureFlag: false,
      clientstatus:'',
      totalCount:0,
      totalCount:0,
      clientId:'',
      systemId:'',
      contractId:'',
      companyName:'',
      CompanyShortNameArr:[],
      contractIdList: [],
      selectedContractId: {
        "value": '',
        "text": ''
      },
      selectedcompanyName: {
        "value": '',
        "text": ''
      },
      type:"ANNEXURES",
      currentPage: 1,
      totalPage: 0,
      totalCount:0,
      pageLimit:CONSTANT.PER_PAGE_DATA,
      resultCount:0,
      offset:0,
      tableColumn: ['Client System ID', 'Client Business Account ID','Company', 'Contract ID','Annexure Name','FileName','Created By','Created Date','Last Modified By','Last Modified Date','Contract Status','Action'],
      tableItems: [],
      innerTableColumn: ['Annexure Description'],
      userName: ''
    }
  },
  computed: {

  },
  mounted() {
    this.getCompanyShortName();
    this.getContractIdList();
    this.getClientAnnexureList();
    var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.userName = userdetail.email;
  },
  methods: {
    showAnnexure() {
      this.showAnnexureFlag = true;
    },
    callParent() {
      this.showAnnexureFlag = false;
      this.offset = 0;
      this.currentPage = 1;
      this.getClientAnnexureList()
    },
    onPageChange(page) {
      this.currentPage = page;
        this.offset = (page - 1) *this.pageLimit
      this.getClientAnnexureList()
    },
    selectCompanyName(data){
        this.selectedcompanyName = data;
        this.companyName = data.text;
    },
    selectContractId(data){
        this.selectedContractId = data;
        this.contractId = data.value;
    },
    searchAnnexure() {
      this.currentPage = 1;
      this.offset= 0;
      this.getClientAnnexureList();
    },
    async getClientAnnexureList(){
      try {
        this.isLoading = true;
        let inputPayload = {
          "offset": this.offset,
          "limit": this.pageLimit,
        }
        if (this.contractId) {
          inputPayload.clientcontractid = this.contractId.value;
        }
        if (this.systemId != '') {
          inputPayload.clientid = this.systemId.trim();
        }
        if (this.companyName) {
          inputPayload.companyname = this.companyName.text;
        }
        let result = await ClientService.getClientAnnexureList(inputPayload)
        this.AnnexureList = result.data.data.rows;
         this.tableItems=result.data.data.rows.map((data)=>{
          return {
            'id':data.id,
            'Client System ID':data.clientcontract.clientid,
            'Client Business Account ID':data.clientcontract.clientbusinessaccountid,
            'Company':data.clientcontract.clientshortname,
            'Contract ID':data.clientcontract.contractidlabel,
            'Annexure Name':data.annexurename,
            'FileName':data.annexureurl,
            'Created By':data.createdby,
            'Created Date':Util.displayDateTimeFormat(data.createddate),
            'Last Modified By':data.lastmodifiedby,
            'Last Modified Date':Util.displayDateTimeFormat(data.lastmodifieddate),
            'Contract Status': CONSTANT.CONTRACT_STATUS[data.clientcontract.contractstatus],
            'Action': `annexure-${data.clientcontract.contractstatus}`,
            'innerTableInfo':{
              'Annexure Description': data.annexuredscription
            }
          }
        })
        this.isLoading = false;
        this.totalCount = result.data.data.count
        if (this.totalCount < this.pageLimit) {
          this.totalPage = 1
        } else {
          this.totalPage = Math.ceil(this.totalCount / this.pageLimit);
        }
        this.isLoading = false;
      } catch(err){
        console.log(err);
        this.isLoading = false;
      }
     },
     fileview(index){
       var link = document.createElement('a');
       link.href = index;
       link.setAttribute('target','_blank');
       window.open(index, '_blank');
       link.remove();
       return true;
     },
     async getCompanyShortName(){
      try {
        var CompanyShortList = []
        let result = await ClientService.getActiveInactiveClientList()
         CompanyShortList = this.getUniqueCompanyList(result.data.data);
        for (var i = 0; i < CompanyShortList.length; i++) {
          this.CompanyShortNameArr.push({
            'value': CompanyShortList[i].ClientMasterID,
            'text': CompanyShortList[i].ClientShortName,
            'ClientBusinessAccountId' : CompanyShortList[i].ClientBusinessAccountId,
          })
        }
      } catch(err){
        console.log(err);
      }
    },
    getUniqueCompanyList(array){
      let mymap = new Map();
      let unique = array.filter(el => {
          const val = mymap.get(el.ClientMasterID);
          if(val) {
              if(el.ClientShortName < val) {
                  mymap.delete(el.ClientMasterID);
                  mymap.set(el.ClientMasterID, el.ClientShortName, el.ClientBusinessAccountId);
                  return true;
              } else {
                  return false;
              }
          }
          mymap.set(el.ClientMasterID, el.ClientShortName,el.ClientBusinessAccountId);
          return true;
      });
      return unique;
    },
    async getContractIdList(){
      try {
        let inputPayload = {};
        let result = await ClientService.getClientContractDropdownList(inputPayload);
        let contractlist = result.data.data;
        for (var i = 0; i < contractlist.length; i++) {
          this.contractIdList.push({
            'value': contractlist[i].id,
            'text': contractlist[i].contractidlabel
          })
        }
      } catch(err){
        console.log(err);
      }
    },
    async removeClientAnnexureData(deleteId){
      try {
        this.isLoading = true;
        let inputPayload = {
          "id": deleteId,
          "lastmodifiedby" : this.userName
        }
        let result = await ClientService.removeClientAnnexureData(inputPayload)
        if(result.data.code == 200){
          this.$alert(result.data.message, this.companyName, "success");
          this.currentPage = 1;
          this.getClientAnnexureList();
          this.isLoading = false;
        }
      } catch(err){
        console.log(err);
      }
     },
     getCustomTableEvent(event) {
       if (event.actionType == "download"){
          var item = this.AnnexureList.find(item => item.id === event.id);
         this.fileview(item.annexureurl);
       }
        if (event.actionType == "delete") {
          this.$confirm("Are you sure you want to delete?","","question").then(() => {
            this.removeClientAnnexureData(event.id);
         }).catch((err)=>{
           console.log(err)
         });
        }
      },
      clearForm() {
        this.currentPage =  1,
        this.offset = 0,
        this.totalPage = 0,
        this.totalCount = 0,
        this.pageLimit = 10,
        this.systemId = '';
        this.companyName = '';
        this.contractId = '';
        this.selectedContractId = {};
        this.selectedcompanyName = {};
        document.getElementById("systemId").value= '';
        this.getClientAnnexureList();
        this.$validator.reset();
      },
   }
}



// WEBPACK FOOTER //
// ./src/modules/clientmanagement/views/ClientAnnexures/ClientAnnexuresListing/ClientAnnexuresListing.component.js